import ReactGA from "react-ga4";

export const initGA = (): void => {
  ReactGA.initialize("G-D5RQKT4EJB"); // Replace with your Measurement ID
};

export const trackPageview = (path: string): void => {
  ReactGA.send({ hitType: "pageview", page: path });
};